export default __webpack_public_path__ + "215b0020aceaa147ebc8237d7a4630f2.png";